import _ from 'lodash'
import PolicyValueRow, { dashedOutOrWithPrecision, PolicyValueRowBasicPremium } from './policy-value-row'
import PolicyValueRowRPUETI from '../layout-without-cash-drop/policy-value-row'
import MESSAGES from 'core/data-model/constants/bi-messages'
import CONSTANTS from 'core/data-model/constants/messages'
import values from 'core/data-model/constants/values'
import { _getMessageUnderiShieldPolicyValueTable } from 'core/service/benefit-illustration/policy-value'
import { checkWaiveAnnualBasicPremiumForReplaceWording } from 'core/service/basic-plan/basic-plan'
import { PolicyLifeProtectPlus } from './policy-value-table-life-protect-plus'
import Mustache from 'mustache'
import { LIFE_PROTECT_PLUS_GROUP_CODES } from 'core/data-model/constants/product-groups'

export const IShieldMessageUnderTable = ({ policyValue, basicPlan }) => {
  const message = _getMessageUnderiShieldPolicyValueTable({
    policyValue,
    basicPlan,
  })
  if (message) {
    return <div className="ishield-conditional-info">{message}</div>
  } else {
    return null
  }
}

const PolicyValueTableLifeReady = (props) => {
  return (
    <div className="policy group" id="policy-value">
      <h3>{MESSAGES.POLICY_VALUE_TABLE}</h3>

      {renderPolicyValueTableForWholeLife(props)}
    </div>
  )
}

const PolicyTable = ({ className, children }) => (
  <table className={`policy-table${className ? ` ${className}` : ''}`} id="policy-value-table">
    {children}
  </table>
)

// $$FlowFixMe

export const PolicyWithOutCashDrop = ({
  yearEndPolicyValues,
  lastYearEndPolicy,
  subtotalAnnualBasicPremium,
  subtotalAnnualRiderPremium,
  grandTotalPremium,
  subtotalCashDrop,
  subtotalLowSavingCashDrop,
  subtotalMediumSavingCashDrop,
  subtotalHighSavingCashDrop,
  basicPlan,
}) => (
  <PolicyTable className="with-cash-drop">
    <thead>
      <tr>
        <td rowSpan={2} width="5%">
          {CONSTANTS.AGE}
        </td>
        <td className="nowrap" rowSpan={2} width="5%">
          {MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR}
        </td>
        <td colSpan={3}>{MESSAGES.PREMIUM_PER_YEAR}</td>
        <td colSpan={3}>{MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}</td>
      </tr>
      <tr>
        <td width="10%">{MESSAGES.BASIC_PLAN}</td>
        <td width="10%">{MESSAGES.RIDER}</td>
        <td width="10%">{MESSAGES.TOTAL}</td>
        <td width="10%">{MESSAGES.CUMULATIVE_PREMIUM}</td>
        <td width="10%">{MESSAGES.POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER}</td>
        <td width="10%">{MESSAGES.DEATH_COVERAGE}</td>
      </tr>
    </thead>
    <tbody>
      {yearEndPolicyValues.map((policyValue, index) => (
        <PolicyValueRow
          key={`policy-value-row-${policyValue.age.value}`}
          age={policyValue.age}
          yearEndPolicy={policyValue.yearEndPolicy}
          cumulativeBasicPremium={policyValue.cumulativeBasicPremium}
          annualBasicPremium={checkWaiveAnnualBasicPremiumForReplaceWording(policyValue, basicPlan)}
          annualRiderPremium={policyValue.annualRiderPremium}
          annualTotalPremium={policyValue.annualTotalPremium}
          surrenderCash={policyValue.surrenderCash}
          deathBenefit={policyValue.deathBenefit}
          cumulativeDeathBenefit={policyValue.cumulativeDeathBenefit}
          basicSumAssured={policyValue.basicSumAssured}
        />
      ))}
      <tr className="total" id={`policy-value-row-${lastYearEndPolicy}`} key={`policy-value-row-${lastYearEndPolicy}`}>
        <td />
        <td />
        <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 2)}</td>
        <td>{dashedOutOrWithPrecision(subtotalAnnualRiderPremium, 2)}</td>
        <td>{dashedOutOrWithPrecision(grandTotalPremium, 2)}</td>
        <td />
        <td />
        <td />
      </tr>
    </tbody>
  </PolicyTable>
)

export const PolicyRPUETIWithOutCashDrop = ({
  yearEndPolicyValues,
  lastYearEndPolicy,
  subtotalAnnualBasicPremium,
  subtotalAnnualRiderPremium,
  grandTotalPremium,
}) => (
  <PolicyTable className="with-cash-drop">
    <thead>
      <tr>
        <td rowSpan={3} width="5%">
          {CONSTANTS.AGE}
        </td>
        <td className="nowrap" rowSpan={3} width="5%">
          {MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR}
        </td>
        <td colSpan={3}>{MESSAGES.PREMIUM_PER_YEAR}</td>
        <td colSpan={3}>{MESSAGES.END_OF_YEAR_POLICY_WITH_BRACKET}</td>
        <td colSpan={2}>{MESSAGES.RPU}</td>
        <td colSpan={4}>{MESSAGES.ETI}</td>
      </tr>
      <tr>
        <td rowSpan={2} width="5%">
          {MESSAGES.BASIC_PLAN}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.RIDER}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.TOTAL}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.CUMULATIVE_PREMIUM}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.DEATH_COVERAGE}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.CASHPAID}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.RPU_SA}
        </td>
        <td colSpan={2} width="10%">
          {MESSAGES.ETI_VALUE}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.CASHPAID}
        </td>
        <td rowSpan={2} width="5%">
          {MESSAGES.ETI_MATURITY}
        </td>
      </tr>
      <tr>
        <td>{MESSAGES.YEAR}</td>
        <td>{MESSAGES.DAY}</td>
      </tr>
    </thead>
    <tbody>
      {yearEndPolicyValues.map((policyValue, index) => (
        <PolicyValueRowRPUETI
          key={`policy-value-row-${policyValue.age.value}`}
          age={policyValue.age}
          yearEndPolicy={policyValue.yearEndPolicy}
          cumulativeBasicPremium={policyValue.cumulativeBasicPremium}
          annualBasicPremium={policyValue.annualBasicPremium}
          annualRiderPremium={policyValue.annualRiderPremium}
          annualTotalPremium={policyValue.annualTotalPremium}
          surrenderCash={policyValue.surrenderCash}
          deathBenefit={policyValue.deathBenefit}
          cumulativeDeathBenefit={policyValue.cumulativeDeathBenefit}
          basicSumAssured={policyValue.basicSumAssured}
          RPUSumAssured={policyValue.RPUSumAssured}
          RPUCashpaid={policyValue.RPUCashpaid}
          ETIYear={policyValue.ETIYear}
          ETIDay={policyValue.ETIDay}
          ETIMaturity={policyValue.ETIMaturity}
          ETICashpaid={policyValue.ETICashpaid}
        />
      ))}
      <tr className="total" id={`policy-value-row-${lastYearEndPolicy}`} key={`policy-value-row-${lastYearEndPolicy}`}>
        <td />
        <td />
        <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 2)}</td>
        <td>{dashedOutOrWithPrecision(subtotalAnnualRiderPremium, 2)}</td>
        <td>{dashedOutOrWithPrecision(grandTotalPremium, 2)}</td>
        <td />
        <td />
        <td />
        <td />
        <td />
        <td />
        <td />
        <td />
        <td />
      </tr>
    </tbody>
  </PolicyTable>
)

export const PolicyWithOutCashDropBasicPremium = ({
  yearEndPolicyValues,
  lastYearEndPolicy,
  subtotalAnnualBasicPremium,
  basicPlan,
}) => (
  <PolicyTable className="with-cash-drop with-cash-drop-basic-premium">
    <thead>
      <tr>
        <td rowSpan={2} width="5%">
          {CONSTANTS.AGE}
        </td>
        <td className="nowrap" rowSpan={2} width="5%">
          {MESSAGES.POLICY_VALUE_TABLE_INSURANCE_YEAR}
        </td>
        <td colSpan={2}>{MESSAGES.BASIC_PREMIUM}</td>
        <td rowSpan={2} width="10%">
          {MESSAGES.DEATH_COVERAGE_END_OF_POLICY}
        </td>
        <td rowSpan={2} width="10%">
          {MESSAGES.SURRENDER_VALUE_END_OF_YEAR}
        </td>
      </tr>
      <tr>
        <td width="10%">{MESSAGES.PER_YEAR}</td>
        <td width="10%">{MESSAGES.CUMULATIVE}</td>
      </tr>
    </thead>
    <tbody>
      {yearEndPolicyValues.map((policyValue, index) => (
        <PolicyValueRowBasicPremium
          key={`policy-value-row-${policyValue.age.value}`}
          age={policyValue.age}
          yearEndPolicy={policyValue.yearEndPolicy}
          annualBasicPremium={checkWaiveAnnualBasicPremiumForReplaceWording(policyValue, basicPlan)}
          cumulativeBasicPremium={policyValue.cumulativeBasicPremium}
          surrenderCash={policyValue.surrenderCash}
          deathBenefit={policyValue.deathBenefit}
        />
      ))}
      <tr className="total" id={`policy-value-row-${lastYearEndPolicy}`} key={`policy-value-row-${lastYearEndPolicy}`}>
        <td />
        <td />
        <td>{dashedOutOrWithPrecision(subtotalAnnualBasicPremium, 2)}</td>
        <td />
        <td />
        <td />
      </tr>
    </tbody>
  </PolicyTable>
)

const PolicyValueContent = ({ basicPlan, yearEndPolicyValues, ...props }) => {
  // Check ETI
  const hasRpuEti = yearEndPolicyValues[0].RPUSumAssured !== undefined || yearEndPolicyValues[0].ETIDay !== undefined
  if (hasRpuEti) {
    return <PolicyRPUETIWithOutCashDrop {...props} yearEndPolicyValues={yearEndPolicyValues} />
  }

  if (basicPlan?.code === 'W99F06A') {
    return (
      <PolicyWithOutCashDropBasicPremium {...props} yearEndPolicyValues={yearEndPolicyValues} basicPlan={basicPlan} />
    )
  }

  if (LIFE_PROTECT_PLUS_GROUP_CODES.includes(basicPlan?.code)) {
    return <PolicyLifeProtectPlus {...props} yearEndPolicyValues={yearEndPolicyValues} basicPlan={basicPlan} />
  }

  return <PolicyWithOutCashDrop {...props} yearEndPolicyValues={yearEndPolicyValues} basicPlan={basicPlan} />
}

const renderPolicyValueTableForWholeLife = ({ policyValue, basicPlan }) => {
  const lastYearEndPolicy = _.get(_.last(policyValue.yearEndPolicyValues), 'yearEndPolicy', 0) + 1

  // $$FlowFixMe
  const policyValueTableProps = { policyValue, basicPlan }
  const addTextDisclaimer = (code) => {
    if (values.LIFETREASURE_GROUP_CODE.includes(code)) {
      return (
        <li>
          <br />
          {MESSAGES.LIFE_TREASURE_FOOTER}
        </li>
      )
    } else if (values.LIFE_READY_18_CAMPAIGN_GROUP.includes(code)) {
      return (
        <li>
          {MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_WAIVE_PREMIUM_LAST_YEAR_BULLET_4}
          <ul>
            <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_WAIVE_PREMIUM_LAST_YEAR_BULLET_4_1}</li>
            <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_WAIVE_PREMIUM_LAST_YEAR_BULLET_4_2}</li>
            <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_WAIVE_PREMIUM_LAST_YEAR_BULLET_4_3}</li>
            <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_WAIVE_PREMIUM_LAST_YEAR_BULLET_4_4}</li>
          </ul>
        </li>
      )
    } else {
      return ''
    }
  }

  const getDisclaimer = () => {
    if (basicPlan.code === 'W99F06A') {
      return (
        <ul>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_EASY_PROTECT_6_ONE}</li>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_EASY_PROTECT_6_TWO}</li>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_EASY_PROTECT_6_THREE}</li>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_EASY_PROTECT_6_FOUR}</li>
        </ul>
      )
    } else if (LIFE_PROTECT_PLUS_GROUP_CODES.includes(basicPlan.code)) {
      const UNDER_CODES = [
        values.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER,
        values.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER,
        values.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER,
      ]

      const isUnderGroup = UNDER_CODES.includes(basicPlan.code)
      return (
        <ul>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_ONE}</li>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_TWO}</li>
          <li>
            {MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_THREE}
            <ul>
              <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_THREE_1}</li>
              <li>
                {Mustache.render(MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_THREE_2, {
                  additionalPercentage: isUnderGroup ? 50 : 100,
                })}
              </li>
              <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_THREE_3}</li>
            </ul>
          </li>
          <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_LIFE_PROTECT_PLUS_FOUR}</li>
        </ul>
      )
    }
    return (
      <ul>
        <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_ONE}</li>
        <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_TWO}</li>
        <li>{MESSAGES.POLICY_VALUE_TABLE_DISCLAIMER_THREE}</li>
        {addTextDisclaimer(basicPlan.code)}
      </ul>
    )
  }

  return (
    <div>
      <div className="table-wrap">
        <PolicyValueContent lastYearEndPolicy={lastYearEndPolicy} basicPlan={basicPlan} {...policyValue} />
      </div>

      <IShieldMessageUnderTable {...policyValueTableProps} />

      <div className="disclaimer">
        {policyValue.expenseRatio ? (
          <div>
            {Mustache.render(MESSAGES.LIFE_PROTECT_PLUS_EXPENSE_RATIO, {
              value: policyValue.expenseRatio,
            })}
          </div>
        ) : null}
        <div>{MESSAGES.NOTE}:</div>
        <div>{getDisclaimer()}</div>
      </div>
    </div>
  )
}

export default PolicyValueTableLifeReady
